// fetch
import { postWithToken } from './fetch.js';

// urls
import urls from './_services.json';

// util
import { getUrl } from './util.js';

export async function getImageDetailInfo(id) {
  const url = `${getUrl(urls.getImageDetailInfo)}/${id}`;
  return await postWithToken(url, {});
}
export async function submitImageShare(params) {
  const url = getUrl(urls.submitImageShare);
  return await postWithToken(url, params);
}

export async function postImageFeedbackSave(params) {
  const url = getUrl(urls.imageFeedbackSave);
  return await postWithToken(url, params);
}
export async function postShareByUser(params) {
  const url = getUrl(urls.shareByUser);
  return await postWithToken(url, params);
}
